import { createSlice } from '@reduxjs/toolkit';

const socketSlice = createSlice({
  name: 'socket',
  initialState: {
    connected: false,
    socketId: null,
    error: null
  },
  reducers: {
    connected: (state, action) => {
      state.connected = true;
      state.socketId = action.payload;
      state.error = null;
    },
    disconnected: (state) => {
      state.connected = false;
      state.socketId = null;
    },
    error: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const socketActions = socketSlice.actions;
export default socketSlice.reducer;